import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { searchParamsToFilters } from '~/features/platform/components/audit-logs/audit-logs-helpers';
import type { AuditLogFilters } from '~/features/platform/types/audit-log.types';
import { requireSystemAdmin } from '~/utils/guards';

/** URL search shape: filter object + the optional drawer-selected id. */
interface AuditLogsSearch extends AuditLogFilters {
  id?: string;
}

const AuditLogsPage = lazy(() => import('~/features/platform/pages/audit-logs-page'));

export const Route = createFileRoute('/_authenticated/_tenant/platform/audit-logs')({
  beforeLoad: requireSystemAdmin(),
  validateSearch: (search: Record<string, unknown>): AuditLogsSearch => {
    const filters = searchParamsToFilters(search);
    return {
      ...filters,
      ...(typeof search.id === 'string' ? { id: search.id } : {}),
    };
  },
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <AuditLogsPage />
    </Suspense>
  ),
});
